import puiActionBar from './ActionBar.vue';
import puiAuthorizedRouterLink from './AuthorizedRouterLink';
import puiHeader from './Header.vue';
import puiHeaderButton from './HeaderButton.vue';
import puiHeaderButtonList from './HeaderButtonList.vue';
import puiHeaderButtonSeparator from './HeaderButtonSeparator.vue';
import puiNotifications from './notifications/Notifications.vue';
import puiSidebar from './Sidebar.vue';
import puiSidebarItem from './SidebarItem.vue';

export {
  puiHeader,
  puiHeaderButton,
  puiHeaderButtonSeparator,
  puiHeaderButtonList,
  puiSidebar,
  puiSidebarItem,
  puiActionBar,
  puiNotifications,
  puiAuthorizedRouterLink,
};

export default [
  puiHeader,
  puiHeaderButton,
  puiHeaderButtonSeparator,
  puiHeaderButtonList,
  puiSidebar,
  puiSidebarItem,
  puiActionBar,
  puiNotifications,
  puiAuthorizedRouterLink,
];
